"use client"

export { MobileMenuIsland as NavbarMobileMenu } from "../navigation-islands"
export type { MobileMenuIslandProps as NavbarMobileMenuProps } from "../navigation-islands"
